export default "__VITE_ASSET__c11b4e6d__"